<template>
    <control-wrapper v-bind="controlWrapper" :styles="styles" :isFocused="isFocused" :appliedOptions="appliedOptions">

        <div style="display:inline-flex">
            <v-select style="width:100px" v-model="formData.year" label="年份" dense :items="yearOptions" @change="getValue" :disabled="readonly"></v-select>
            <v-select style="width:100px" v-show="rootData.GE8002009E == '月度'" v-model="formData.month" dense label="月份" :disabled="readonly" @change="getValue"
                :items="monthOptions"></v-select>
            <v-select style="width:100px" v-show="rootData.GE8002009E=='季度'" v-model="formData.quarter" dense label="季度" :disabled="readonly" @change="getValue"
                :items="quarterOptions"></v-select>

        </div>
        <v-text-field style="display:none" :id="control.id + '-input'" v-model="control.data"
            v-bind="vuetifyProps('v-text-field')" @input="onChange" />
    </control-wrapper>
</template>

<script>
import { formatIs, rankWith, } from '@jsonforms/core';

import { rendererProps, useJsonFormsControl } from '@jsonforms/vue2';
import { useVuetifyControl, ControlWrapper } from '@jsonforms/vue2-vuetify';
import { defineComponent, ref } from 'vue';

const controlRenderer = defineComponent({
    name: "report-data",
    components: {
        ControlWrapper
    },
    inject: ['jsonforms'],
    props: {
        ...rendererProps(),
    },
    setup(props) {

        const quarter = ref('')
        let date = new Date();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        let yearOptions = [
            { text: year + '年', value: year },
            { text: year - 1 + '年', value: year - 1 },
            { text: year - 2 + '年', value: year - 2 },
            { text: year - 3 + '年', value: year - 3 },
            { text: year - 4 + '年', value: year - 4 },
        ];


        const monthOptions = ref([
            { text: '1月', value: '01' },
            { text: '2月', value: '02' },
            { text: '3月', value: '03' },
            { text: '4月', value: '04' },
            { text: '5月', value: '05' },
            { text: '6月', value: '06' },
            { text: '7月', value: '07' },
            { text: '8月', value: '08' },
            { text: '9月', value: '09' },
            { text: '10月', value: '10' },
            { text: '11月', value: '11' },
            { text: '12月', value: '12' }
        ])
        const quarterOptions = [
            { text: '1季度', value: '-03-31' },
            { text: '2季度', value: '-06-30' },
            { text: '3季度', value: '-09-30' },
            { text: '4季度', value: '-12-31' },
        ]
        let formData = ref({
            year: '',
            month: '',
            quarter: ''
        })
        const control = useVuetifyControl(useJsonFormsControl(props), (value) => value || undefined);
        return { ...control, formData, quarterOptions, monthOptions, yearOptions }
    },
    methods: {
        getValue(){
            let str=''
            if(this.rootData.GE8002009E=='年度'){
                str=this.formData.year + '-12-31'
            }else if(this.rootData.GE8002009E=='季度'){
                str=this.formData.year + this.formData.quarter
            }else {
                str=this.formData.year + "-"+ this.formData.month
            }
            this.control.data=str;
            this.onChange(this.control.data)
        }
    },
    computed: {
        rootData() {
            return this.jsonforms.core.data
        },
       
        readonly(){
            return this.jsonforms.readonly

        }
          
          
  
    },
    watch: {
        'rootData.GE8002009E': {
            handler(newVal, oldVal) {
                if(newVal!=oldVal){
                let date = new Date();
                let month = date.getMonth() + 1;
                let year = date.getFullYear();
                this.formData.year = year
                if (newVal == '月度') {
                    this.formData.month = month < 10 ? "0" + month : month.toString()

                }
                if (newVal == '季度') {
                    if (month <= 3) {
                        this.formData.quarter = '-03-31'
                    } else if (month > 3 && month <= 6) {
                        this.formData.quarter = '-06-30'
                    } else if (month > 6 && month <= 9) {
                        this.formData.quarter = '-09-30'
                    } else {
                        this.formData.quarter = '-12-31'
                    }
                }
                this.getValue();
            }

            },
            deep: true, //深度监听
            immediate: true //立即执行
        },
    }
})

export default controlRenderer;
export const entry = {
    renderer: controlRenderer,
    tester: rankWith(10, formatIs("zysl-reportDate")),
};
</script>

<style lang="less" scoped>


</style>
